import type { InvitationRoleRef } from '@/types/api';

/**
 * The roles an invitation grants, as one readable line.
 *
 * Shared by every place that shows an invitation as a sentence rather than as
 * badges (the clinic picker, onboarding), so the separator and the ordering are
 * decided once. `PeoplePage` renders badges instead — there the deleted-role
 * case earns its own label, which a joined string cannot carry.
 */
export function invitationRoleNames(roles: readonly InvitationRoleRef[]): string {
  return roles.map((r) => r.roleName).join(', ');
}
